import { Card, Typography, Input, Button, Form, DatePicker, Tabs } from "antd";
import { useEffect, useState } from "react";
import { debounce } from "lodash";
import * as Validation from "../../utils/helper/validation";
import { DownloadOutlined } from "@ant-design/icons";
import SalesReports from "./ReportTabs/SalesReports";
import PaymentReports from "./ReportTabs/PaymentReports";
import LateOrdersReports from "./ReportTabs/LateOrdersReports";
import globalRequest from "../../utils/global/globalRequest";
import * as Apis from "../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import toast from "react-hot-toast";
import "jspdf-autotable";
import { addDeleteGetLocalStorage, storageKeys } from "../../utils/global/localData";
import { checkPermissionAction, exportCSV, exportPDf, formatDateFunction, formatText, roundToDecimal } from "../../utils/helper/utils";
import { jwtDecode } from "jwt-decode";
import { useNavigate, useLocation  } from "react-router-dom";
import DiscountCouponReports from "./ReportTabs/DiscountCouponReports";
import dayjs from "dayjs";
import RefundOrdersReports from "./ReportTabs/RefundOrdersReports";
import CancelledReports from "./ReportTabs/CancelledReports";
import SalesDetailsReport from "./ReportTabs/SalesDetailsReport";
import WalletReports from "./ReportTabs/WalletReports";
import DriverReports from "./ReportTabs/DriverReports";
import AdminActivityLogsReports from "./ReportTabs/AdminActivityLogsReports";
import { getEventLabel } from "../../utils/helper/constants";

const Report = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const { Search } = Input;
  const navigate = useNavigate();

  const [permissionJson, setPermissionJson] = useState([]);
  const locationState = location.state || {};
  const returnedInputData = locationState.inputData || {};
  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
      setPermissionJson(permissionJson);
    }
    if (
      !checkPermissionAction("Sales By Zone Report", permissionJson, "view") &&
      !checkPermissionAction("Sales By Item Report", permissionJson, "view") &&
      !checkPermissionAction("Sales By Customer Report", permissionJson, "view") &&
      !checkPermissionAction("Sales By Order Type Report", permissionJson, "view") &&
      !checkPermissionAction("Sales By Delivery Mode Report", permissionJson, "view") &&
      !checkPermissionAction("Sales By Time Slot Report", permissionJson, "view") &&
      !checkPermissionAction("Sales By Vendor Report", permissionJson, "view") &&
      !checkPermissionAction("Sales By Driver Report", permissionJson, "view") &&
      !checkPermissionAction("Coupon Report", permissionJson, "view") &&
      !checkPermissionAction("Payment Report", permissionJson, "view") &&
      !checkPermissionAction("Sales Details Report", permissionJson, "view") &&
      !checkPermissionAction("Late Order Report", permissionJson, "view") &&
      !checkPermissionAction("Refund Order Report",permissionJson, "view") &&
      !checkPermissionAction("Cancelled Order Report",permissionJson, "view") &&
      !checkPermissionAction("Wallet Reports",permissionJson, "view") && 
      !checkPermissionAction("Driver Reports", permissionJson, "view") &&
      !checkPermissionAction("Driver Reports",permissionJson, "view") 
    ) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [inputData, setInputData] = useState({
    search: "",
    start_date: returnedInputData.start_date || dayjs().format("YYYY-MM-DD"),
    end_date: returnedInputData.end_date || dayjs().format("YYYY-MM-DD"),
  });

  const handleDateChange = (dates, dateStrings) => {
    const [startdate, enddate] = dateStrings; // Get the date strings from the RangePicker

    if (!startdate || !enddate) {
      toast.error("Please select both start date and end date.");
      return;
    }
    // Update the filter with the selected start and end dates
    setInputData((prevState) => ({
      ...prevState,
      start_date: startdate, // Set the start date
      end_date: enddate, // Set the end date
    }));
  };

  const handleSearchDebounced = debounce((value) => {
    setInputData((prev) => ({ ...prev, search: value }));
  }, 300); // Debounce delay in milliseconds (adjust as needed)

  const getDropzoneName = (item) => {
    if (Array.isArray(item?.pickupPointDetails?.dropZoneLocales)) {
      const enDropZone = item.pickupPointDetails.dropZoneLocales.find(
        dz => dz.languageCode === "en"
      );
      return enDropZone?.name || "N/A";
    }
    return "N/A";
  };

  const getZoneName = (item) => {
    return item?.branchDetails?.zoneDetails[0]?.name || "N/A";
  };
  const getCustomerZoneName = (item) => {
    return item?.customerZoneDetails?.[0]?.name || item?.pickupPointDetails?.zoneDetails?.[0]?.name || "N/A";
  }
  const getVendorName = (item) => {
    if (!Array.isArray(item?.orderDetails) || item.orderDetails.length === 0) {
      return "N/A";
    }
    const vendor = item.orderDetails[0]?.vendorDetails;
    if (!vendor) return "N/A";
    return `${vendor.firstName || ""} ${vendor.lastName || ""}`.trim() || "N/A";
  };

  const exportData = async (value) => {
    console.log("payment report", value, mainTabIndex);
    if (value) {
      let subTab = subTabIndex;
      if (mainTabIndex === 1 || mainTabIndex === "1") {
        if (!subTab || subTab === 1 || subTab === "1") {
          //api call for get data
          dispatch(changeLoader(true));
          try {
            let params = {
              ...inputData,
              type: "export",
            };
            let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_ZONE, "get", {}, { params: params }, true);
            let apiResponse = response.data;
            if (apiResponse?.status === "SUCCESS") {
              if (apiResponse?.data) {
                let exportData = [];
                for (let key in apiResponse?.data) {
                  let item = apiResponse?.data[key];
                  exportData.push({
                    'Zone Name': item.zoneName,
                    'Total Orders': item.orderCount,
                    'Total Sales WithTax': roundToDecimal(item.totalAmount, 2),
                    'Total Sales Without Tax': roundToDecimal(item.totalSubTotal, 2),
                  });
                }
                if (exportData.length > 0) {
                  if (value === "csv") {
                    exportCSV(exportData, "salesByZoneReport.csv");
                  }
                  if (value === "pdf") {
                    // Generate the table data
                    const headers = ["Zone Name", "Total Orders", "Total Sales With Tax", "Total Sales Without Tax"];
                    const rows = exportData.map((item) => [
                      item["Zone Name"],
                      item["Total Orders"],
                      item["Total Sales WithTax"],
                      item["Total Sales Without Tax"],
                    ]);
                    exportPDf(headers, rows, "salesByZoneReport.pdf");
                  }
                } else {
                  // console.log("No data to export");
                }
              }
            } else {
              toast.error(apiResponse?.message);
            }
          } catch (e) {
            toast.error(e?.message);
          }
          dispatch(changeLoader(false));
        }
        if (subTab === 2 || subTab === "2") {
          //api call for get data
          dispatch(changeLoader(true));
          try {
            let params = {
              ...inputData,
              type: "export",
            };
            let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_ITEM, "get", {}, { params: params }, true);
            let apiResponse = response.data;
            if (apiResponse?.status === "SUCCESS") {
              if (apiResponse?.data) {
                let exportData = [];
                for (let key in apiResponse?.data) {
                  let item = apiResponse?.data[key];
                  exportData.push({
                    'Item Name': item.productName,
                    'Total Quantity Sold': item.totalQuantitySold,
                    'Total Amount': roundToDecimal(item.totalAmount, 2),
                    'Average Price': roundToDecimal(item.averagePrice, 2),
                  });
                }
                if (exportData.length > 0) {
                  if (value === "csv") {
                    exportCSV(exportData, "salesByItemReport.csv");
                  }
                  if (value === "pdf") {
                    // Generate the table data
                    const headers = ["Item Name", "Total Quantity Sold", "Total Amount", "Average Price"];
                    const rows = exportData.map((item) => [item["Item Name"], item["Total Quantity Sold"], item["Total Amount"], item["Average Price"]]);
                    exportPDf(headers, rows, "salesByItemReport.pdf");
                  }
                } else {
                  // console.log("No data to export");
                }
              }
            } else {
              toast.error(apiResponse?.message);
            }
          } catch (e) {
            toast.error(e?.message);
          }
          dispatch(changeLoader(false));
        }
        if (subTab === 3 || subTab === "3") {
          //api call for get data
          dispatch(changeLoader(true));
          try {
            let params = {
              ...inputData,
              type: "export",
            };
            let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_CUSTOMER, "get", {}, { params: params }, true);
            let apiResponse = response.data;
            if (apiResponse?.status === "SUCCESS") {
              if (apiResponse?.data) {
                let exportData = [];
                for (let key in apiResponse?.data) {
                  let item = apiResponse?.data[key];
                  exportData.push({
                    'Mobile No': item.userMobileNo,
                    'Total Orders': item.totalOrders,
                    'Total Sales WithTax': roundToDecimal(item.totalSalesWithTax, 2),
                    'Total Sales Without Tax': roundToDecimal(item.salesWithoutTax, 2),
                  });
                }
                if (exportData.length > 0) {
                  if (value === "csv") {
                    exportCSV(exportData, "salesByCustomerReport.csv");
                  }
                  if (value === "pdf") {
                    // Generate the table data
                    const headers = ["MobileNo", "Total Orders", "Total Sales With Tax", "Total Sales Without Tax"];
                    const rows = exportData.map((item) => [
                      item["Mobile No"],
                      item["Total Orders"],
                      item["Total Sales WithTax"],
                      item["Total Sales Without Tax"],
                    ]);
                    exportPDf(headers, rows, "salesByCustomerReport.pdf");
                  }
                } else {
                  // console.log("No data to export");
                }
              }
            } else {
              toast.error(apiResponse?.message);
            }
          } catch (e) {
            toast.error(e?.message);
          }
          dispatch(changeLoader(false));
        }
        if (subTab === 4 || subTab === "4") {
          dispatch(changeLoader(true));
          try {
            let params = {
              ...inputData,
              type: "export",
            };
            let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_ORDER_TYPE, "get", {}, { params: params }, true);
            let apiResponse = response.data;
            console.log("apiResponseOrder", apiResponse);
            if (apiResponse?.status === "SUCCESS") {
              if (apiResponse?.data) {
                let exportData = [];
                for (let key in apiResponse?.data) {
                  let item = apiResponse?.data[key];
                  exportData.push({
                    'Order Type': item.orderType,
                    'Total Amount': item.totalAmount,
                    'Total Orders': item.totalCount,
                  });
                }
                if (exportData.length > 0) {
                  if (value === "csv") {
                    exportCSV(exportData, "salesByOrderTypeReport.csv");
                  }
                  if (value === "pdf") {
                    const headers = ["Order Type", "Total Amount", "Total Orders"];
                    const rows = exportData.map((item) => [
                      item["Order Type"],
                      item["Total Amount"],
                      item["Total Orders"],
                    ]);
                    exportPDf(headers, rows, "salesByOrderTypeReport.pdf");
                  }
                } else {
                  // console.log("No data to export");
                }
              }
            } else {
              toast.error(apiResponse?.message);
            }
          } catch (e) {
            toast.error(e?.message);
          }
          dispatch(changeLoader(false));
        }
        if (subTab === 5 || subTab === "5") {
          dispatch(changeLoader(true));
          try {
            let params = {
              ...inputData,
              type: "export",
            };
            let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_DELIVERY_MODE, "get", {}, { params: params }, true);
            let apiResponse = response.data;
            if (apiResponse?.status === "SUCCESS") {
              if (apiResponse?.data) {
                let exportData = [];
                for (let key in apiResponse?.data) {
                  let item = apiResponse?.data[key];
                  exportData.push({
                    'Delivery Mode': item.deliveryMode,
                    'Total Amount': item.totalAmount,
                    'Total Orders': item.totalCount,
                  });
                }
                if (exportData.length > 0) {
                  if (value === "csv") {
                    exportCSV(exportData, "salesByDeliveryModeReport.csv");
                  }
                  if (value === "pdf") {
                    const headers = ["Delivery Mode", "Total Amount", "Total Orders"];
                    const rows = exportData.map((item) => [
                      item["Delivery Mode"],
                      item["Total Amount"],
                      item["Total Orders"],
                    ]);
                    exportPDf(headers, rows, "salesByDeliveryModeReport.pdf");
                  }
                } else {
                  // console.log("No data to export");
                }
              }
            } else {
              toast.error(apiResponse?.message);
            }
          } catch (e) {
            toast.error(e?.message);
          }
          dispatch(changeLoader(false));
        }
        if (subTab === 6 || subTab === "6") {
          dispatch(changeLoader(true));
          try {
            let params = {
              ...inputData,
              type: "export",
            };
            let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_TIME_SLOT, "get", {}, { params: params }, true);
            let apiResponse = response.data;
            if (apiResponse?.status === "SUCCESS") {
              if (apiResponse?.data) {
                let exportData = [];
                for (let key in apiResponse?.data) {
                  let item = apiResponse?.data[key];
                  exportData.push({
                    'Time Slot': item.timeSlot,
                    'Total Amount': item.totalAmount,
                    'Total Orders': item.totalCount,
                  });
                }
                if (exportData.length > 0) {
                  if (value === "csv") {
                    exportCSV(exportData, "salesByTimeSlotReport.csv");
                  }
                  if (value === "pdf") {
                    const headers = ["Time Slot", "Total Amount", "Total Orders"];
                    const rows = exportData.map((item) => [
                      item["Time Slot"],
                      item["Total Amount"],
                      item["Total Orders"],
                    ]);
                    exportPDf(headers, rows, "salesByTimeSlotReport.pdf");
                  }
                } else {
                  // console.log("No data to export");
                }
              }
            } else {
              toast.error(apiResponse?.message);
            }
          } catch (e) {
            toast.error(e?.message);
          }
          dispatch(changeLoader(false));
        }
        if (subTab === 7 || subTab === "7") {
          dispatch(changeLoader(true));
          try {
            let params = {
              ...inputData,
              type: "export",
            };

            let response = await globalRequest(
              Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_VENDOR,
              "get",
              {},
              { params },
              true
            );

            let apiResponse = response.data;

            if (apiResponse?.status === "SUCCESS") {
              const items = apiResponse?.data?.data?.items || [];

              let exportData = items.map((item) => ({
                "Store Name": item.storeName,
                "Total Orders": item.totalOrders,
                "Total Amount": item.totalAmount,
              }));

              if (exportData.length > 0) {
                if (value === "csv") {
                  exportCSV(exportData, "salesByVendorReport.csv");
                }

                if (value === "pdf") {
                  const headers = [
                    "Store Name",
                    "Total Orders",
                    "Total Amount",
                  ];
                  const rows = exportData.map((item) => [
                    item["Store Name"],
                    item["Total Orders"],
                    item["Total Amount"],
                  ]);
                  exportPDf(headers, rows, "salesByVendorReport.pdf");
                }
              } else {
                toast.error("No data found to export.");
              }
            } else {
              toast.error(apiResponse?.message || "Something went wrong");
            }
          } catch (e) {
            toast.error(e?.message || "Error during export");
          }
          dispatch(changeLoader(false));
        }
        if (subTab === 8 || subTab === "8") {
          dispatch(changeLoader(true));
          try {
            let params = {
              ...inputData,
              type: "export",
            };

            let response = await globalRequest(
              Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_DRIVER,
              "get",
              {},
              { params },
              true
            );

            let apiResponse = response.data;
            if (apiResponse?.status === "SUCCESS") {
              const items = apiResponse?.data || [];

              let exportData = items.map((item) => ({
                "Driver Name": item.driverName || "-",
                "Total Orders": item.totalOrder || 0,
                "Total Amount": item.totalAmount?.toFixed(2) || "0.00",
              }));

              if (exportData.length > 0) {
                if (value === "csv") {
                  exportCSV(exportData, "salesByDriverReport.csv");
                }

                if (value === "pdf") {
                  const headers = ["Driver Name", "Total Orders", "Total Amount"];
                  const rows = exportData.map((item) => [
                    item["Driver Name"],
                    item["Total Orders"],
                    item["Total Amount"],
                  ]);
                  exportPDf(headers, rows, "salesByDriverReport.pdf");
                }
              } else {
                toast.error("No data found to export.");
              }
            } else {
              toast.error(apiResponse?.message || "Something went wrong");
            }
          } catch (e) {
            toast.error(e?.message || "Error during export");
          }
          dispatch(changeLoader(false));
        }
      }
      if (mainTabIndex === 2 || mainTabIndex === "2") {
        dispatch(changeLoader(true));
        try {
          let params = {
            ...inputData,
            type: "export",
          };
          let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_COUPON_REPORT, "get", {}, { params: params }, true);
          let apiResponse = response.data;
          if (apiResponse?.status === "SUCCESS") {
            if (apiResponse?.data) {
              let exportData = [];
              for (let key in apiResponse?.data?.data?.data) {
                let item = apiResponse?.data?.data?.data[key];
                exportData.push({
                  Id: item.id,
                  'Coupon Code': item.couponCode,
                  'Usage Count': item.usageCount,
                });
              }
              if (exportData.length > 0) {
                if (value === "csv") {
                  exportCSV(exportData, "discountCoupoonReports.csv");
                }
                if (value === "pdf") {
                  // Generate the table data
                  const headers = ["S.No", "Coupon Name", "Total Usage Count"];
                  const rows = exportData.map((item) => [item.Id, item["Coupon Code"], item["Usage Count"]]);
                  exportPDf(headers, rows, "discountCoupoonReports.pdf");
                }
              } else {
                // console.log("No data to export");
              }
            }
          } else {
            toast.error(apiResponse?.message);
          }
        } catch (e) {
          toast.error(e?.message);
        }
        dispatch(changeLoader(false));
      }
      if (mainTabIndex === 3 || mainTabIndex === "3") {
        dispatch(changeLoader(true));
        try {
          let params = {
            ...inputData,
            // orderType: "asc",
            type: "export",
          };
          let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT, "get", {}, { params: params }, true);
          let apiResponse = response.data;
          if (apiResponse?.status === "SUCCESS") {
            if (apiResponse?.data) {
              let exportData = [];
              for (let key in apiResponse?.data?.data?.data) {
                let item = apiResponse?.data?.data?.data[key];
                let cardSchemeValue = "";
                if (item?.method === "credit_card" || item?.method === "apple_pay") {
                  cardSchemeValue = item?.chargeResponseJson?.card?.scheme;
                } else {
                  cardSchemeValue = item?.chargeResponseJson?.paymentBrand;
                }
                exportData.push({
                  'Order Number': item?.order?.orderNumber,
                  'Transaction ID': item?.transactionId,
                  'Customer Information':
                    item?.order?.userDetails?.firstName +
                    " " +
                    item?.order?.userDetails?.lastName +
                    " |" +
                    item?.order?.userDetails?.mobileNo,
                  'Address': item?.order?.addressDetails?.address,
                  'Sub Total': roundToDecimal(item?.order?.priceDetails?.sub_total, 2),
                  'Coupon Discount': roundToDecimal(item?.order?.priceDetails?.coupon_discount, 2),
                  'Drop Zone Discount': roundToDecimal(item?.order?.priceDetails?.pickup_discount, 2),
                  'Tax': roundToDecimal(item?.order?.priceDetails?.vat, 2),
                  'Shipping': item?.order?.priceDetails?.timeslot_discount,
                  'Amount': roundToDecimal(item?.amount, 2),
                  'Payment Status': item?.paymentStatus,
                  'Method': item?.method,
                  'Payment Network':cardSchemeValue,
                  "Payment Date": formatDateFunction(item?.createdAt, "dd/mm/yyyy"),
                });
              }
              if (exportData.length > 0) {
                if (value === "csv") {
                  exportCSV(exportData, "paymentReport.csv");
                }
                if (value === "pdf") {
                  // Generate the table data
                  const headers = [
                    "orderNumber",
                    "transactionId",
                    // "Customer Information",
                    // "address",
                    "subTotal",
                    "couponDiscount",
                    "dropZoneDiscount",
                    "tax",
                    "shipping",
                    "amount",
                    "paymentStatus",
                    "method",
                  ];
                  const rows = exportData.map((item) => [
                    item["Order Number"],
                    item["Transaction ID"],
                    // item.customerInformation,
                    // item.address,
                    item["Sub Total"],
                    item["Coupon Discount"],
                    item["Drop Zone Discount"],
                    item.Tax,
                    item.Shipping,
                    item.Amount,
                    item["Payment Status"],
                    item.Method,
                  ]);
                  exportPDf(headers, rows, "paymentReport.pdf");
                }
              } else {
                // console.log("No data to export");
              }
            }
          } else {
            toast.error(apiResponse?.message);
          }
        } catch (e) {
          toast.error(e?.message);
        }
        dispatch(changeLoader(false));
      }
      if (mainTabIndex === 4 || mainTabIndex === "4") {
        dispatch(changeLoader(true));
        try {
          let params = {
            ...inputData,
            type: "export",
          };
          let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_REFUND_ORDERS, "get", {}, { params: params }, true);
          let apiResponse = response.data;
          if (apiResponse?.status === "SUCCESS") {
            if (apiResponse.data.data) {
              let exportData = [];
              for (let key in apiResponse?.data?.data) {
                let item = apiResponse?.data?.data[key];
                exportData.push({
                  'Order Number': item.orderDetails.orderNumber || 'N/A',
                  'Refund Id': item.refundId || 'N/A',
                  'Customer Information': ( item?.orderDetails?.userDetails?.firstName ) + ' ' + (  item?.orderDetails?.userDetails?.mobileNo),
                  'SubTotal': item.orderDetails.priceDetails?.sub_total,
                  'Coupon Discount': item.orderDetails.priceDetails?.coupon_discount,
                  'Drop Zone Discount': item.orderDetails.priceDetails?.pickup_discount,
                  'Tax': item.orderDetails.priceDetails?.vat,
                  'Refund Amount': item.refundAmount,
                  'Refund Status': item.refundStatus,
                  'Refund Reason': item.refundReason,
                  'Order Status' : item.orderDetails.status,
                  'Payment Method': item?.refundMode === "credit_card" ? "Credit Card" : item?.refundMode === "apple_pay" ? "Apple Pay" : item?.refundMode || "N/A",
                  'Grand Total' : item.orderDetails.priceDetails?.total_amount,
                  'Refund Date': formatDateFunction(item?.createdAt, "yyyy-mm-dd", true) || "N/A",
                });
              }
              if (exportData.length > 0) {
                if (value === "csv") {
                  exportCSV(exportData, "refundOrderReports.csv");
                }
                if (value === "pdf") {
                  const headers = [
                    "Order Number",
                    "Refund Id",
                    "Customer Information",
                    "SubTotal",
                    "Coupon Discount",
                    "Drop Zone Discount",
                    "Tax",
                    "Refund Amount",
                    "Refund Status",
                    "Refund Reason",
                    "Grand Total",
                    "Order Status",
                    "Refund Date",

                  ];
                  const rows = exportData.map((item) => [
                    item["Order Number"],
                    item["Refund Id"],
                    item["Customer Information"],
                    item["SubTotal"],
                    item["Coupon Discount"],
                    item["Drop Zone Discount"],
                    item["Tax"],
                    item["Refund Amount"],
                    item["Refund Status"],
                    item["Refund Reason"],
                    item["Grand Total"],
                    item["Order Status"],
                    item["Refund Date"],
                  ]);
                  exportPDf(headers, rows, "refundOrderReports.pdf");
                }
              }
            }
          } else {
            toast.error(apiResponse?.message);
          }
        } catch (e) {
          toast.error(e?.message);
        }
        dispatch(changeLoader(false));
      }
      if (mainTabIndex === 5 || mainTabIndex === "5") {
        dispatch(changeLoader(true));
        try {
          let params = {
            ...inputData,
            type: "export",
          };
          let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_LATE_ORDERS, "get", {}, { params: params }, true);
          let apiResponse = response.data;
          if (apiResponse?.status === "SUCCESS") {
            if (apiResponse?.data) {
              let exportData = [];
              for (let key in apiResponse?.data?.lateOrderData) {
                let item = apiResponse?.data?.lateOrderData[key];
                exportData.push({
                  'Order Number': item.orderNumber,
                  'Branch Name': item.branchName,
                  'Driver Name': item.driverName,
                  'Order Type': item.orderType,
                  'Delivery Mode': item.deliveryMode,
                  'Dropzone' : item.dropZone,
                  'Zone': item.zone,
                  'Payment Mothod': item.paymentMethod,
                  'Total Amount': roundToDecimal(item.totalAmount, 2),
                  'Order Date': item.orderDate,
                  'Delivery Date': item.deliveryDate,
                  'Time Slot': item.scheduledTime,
                  'Actual Delivery Date': formatDateFunction(item.actualDeliveryDate, "dd/mm/yyyy", true)
                });
              }
              if (exportData.length > 0) {
                if (value === "csv") {
                  exportCSV(exportData, "lateOrderReports.csv");
                }
                if (value === "pdf") {
                  const headers = [
                    "Order Number",
                    "Branch Name",
                    "Driver Name",
                    "Order Type",
                    "Delivery Mode",
                    "Drop Zone",
                    "Zone",
                    "Payment Method",
                    "Total Amount",
                    "Order Date",
                    "Delivery Date",
                    "Time Slot",
                    "Actual Delivery Date",
                  ];
                  const rows = exportData.map((item) => [
                    item["Order Number"],
                    item["Branch Name"],
                    item["Driver Name"],
                    item["Order Type"],
                    item["Delivery Mode"],
                    item["Drop Zone"],
                    item["Zone"],
                    item["Payment Method"],
                    item["Total Amount"],
                    item["Order Date"],
                    item["Delivery Date"],
                    item["Time Slot"],
                    item["Actual Delivery Date"],
                  ]);
                  exportPDf(headers, rows, "lateOrderReports.pdf");
                }
              }
            }
          } else {
            toast.error(apiResponse?.message);
          }
        } catch (e) {
          toast.error(e?.message);
        }
        dispatch(changeLoader(false));
      }
      if (mainTabIndex === 6 || mainTabIndex === "6") {
        dispatch(changeLoader(true));
        try {
          let params = {
            ...inputData,
            type: "export",
          };

          let response = await globalRequest(
            Apis.MANAGE_REPORT.GET_ALL_CANCELLED_ORDERS,
            "get",
            {},
            { params },
            true
          );

          let apiResponse = response.data;
          if (apiResponse?.status === "SUCCESS") {
            const apiData = apiResponse?.data?.data || [];
            let exportData = [];

            for (let item of apiData) {
              exportData.push({
                "Order Number": item?.orderNumber || "",
                "Transaction ID": item?.transactionId || "",
                "Customer Name": item?.userName || "",
                "Customer Email": item?.userEmail || "",
                "Customer Mobile": item?.userMobile || "",
                "Total Amount": item?.totalAmount?.toFixed(2) || "0.00",
                "Payment Method": item?.paymentMethod || "",
                "Payment Status": item?.paymentStatus || "",
                "Cancel Reason": item?.cancelReason || "N/A",
                "Delivery Mode": item?.deliveryMode || "",
                "Delivery Date": formatDateFunction(item?.deliveryDate, "dd/mm/yyyy"),
                "Payment Date": formatDateFunction(item?.createdAt, "dd/mm/yyyy"),
              });
            }

            if (exportData.length > 0) {
              if (value === "csv") {
                exportCSV(exportData, "CancelledOrdersReport.csv");
              }

              if (value === "pdf") {
                const headers = [
                  "Order Number",
                  "Transaction ID",
                  "Customer Name",
                  "Customer Email",
                  "Customer Mobile",
                  "Total Amount",
                  "Payment Method",
                  "Payment Status",
                  "Cancel Reason",
                  "Delivery Mode",
                  "Delivery Date",
                  "Payment Date",
                ];

                const rows = exportData.map((item) => [
                  item["Order Number"],
                  item["Transaction ID"],
                  item["Customer Name"],
                  item["Customer Email"],
                  item["Customer Mobile"],
                  item["Total Amount"],
                  item["Payment Method"],
                  item["Payment Status"],
                  item["Cancel Reason"],
                  item["Delivery Mode"],
                  item["Delivery Date"],
                  item["Payment Date"],
                ]);

                exportPDf(headers, rows, "CancelledOrdersReport.pdf");
              }
            } else {
              toast.error("No data available to export");
            }
          } else {
            toast.error(apiResponse?.message || "Failed to export report");
          }
        } catch (e) {
          toast.error(e?.message || "Something went wrong");
        }
        dispatch(changeLoader(false));
      }
      if (mainTabIndex === 7 || mainTabIndex === "7") {
        dispatch(changeLoader(true));
        try {
          let params = {
            ...inputData,
            type: "export",
          };

          let response = await globalRequest(
            Apis.MANAGE_REPORT.GET_ALL_SALES_DETAILS_REPORT,
            "get",
            {},
            { params },
            true
          );

          let apiResponse = response.data;
          if (apiResponse?.status === "SUCCESS") {
            const apiData = apiResponse?.data?.data || [];
            let exportData = [];

            for (let item of apiData) {
              exportData.push({
                "Order Number": item?.orderNumber || "",
                "Branch Name": item?.branchDetails?.name || "N/A",
                "Vendor Name": getVendorName(item),
                "Driver Name": item?.driverDetails?.driverName || "N/A",
                "Delivery Mode": formatText(item?.deliveryMode),
                "Dropzone": getDropzoneName(item),
                "Branch Zone": getZoneName(item),
                "Customer ZoneName": getCustomerZoneName(item) || "N/A",
                "Payment Method": formatText(item?.paymentMethod),
                "Status": formatText(item?.status),
                "Total Amount": item?.totalAmount ? Number(item.totalAmount).toFixed(2) : "0.00",
                "Order Date": item?.createdAt ? formatDateFunction(item.createdAt, "dd/mm/yyyy") : "N/A",
                "Delivery Date": item?.deliveryDate ? formatDateFunction(item.deliveryDate, "dd/mm/yyyy") : "N/A",
              });
            }

            if (exportData.length > 0) {
              if (value === "csv") {
                exportCSV(exportData, "SalesDetailsReport.csv");
              }

              if (value === "pdf") {
                const headers = [
                  "Order Number",
                  "Branch Name",
                  "Vendor Name",
                  "Driver Name",
                  "Delivery Mode",
                  "Dropzone",
                  "Branch Zone",
                  "Customer ZoneName",
                  "Payment Method",
                  "Status",
                  "Total Amount",
                  "Order Date",
                  "Delivery Date",
                ];

                const rows = exportData.map((item) => [
                  item["Order Number"],
                  item["Branch Name"],
                  item["Vendor Name"],
                  item["Driver Name"],
                  item["Delivery Mode"],
                  item["Dropzone"],
                  item["Branch Zone"],
                  item["Customer ZoneName"],
                  item["Payment Method"],
                  item["Status"],
                  item["Total Amount"],
                  item["Order Date"],
                  item["Delivery Date"],
                ]);

                exportPDf(headers, rows, "SalesDetailsReport.pdf");
              }
            } else {
              toast.error("No data available to export");
            }
          } else {
            toast.error(apiResponse?.message || "Failed to export report");
          }
        } catch (e) {
          toast.error(e?.message || "Something went wrong");
        }
        dispatch(changeLoader(false));
      }
      if (mainTabIndex === 8 || mainTabIndex === "8") {
        dispatch(changeLoader(true));
        try {
          const params = { ...inputData, type: "export" };

          const res = await globalRequest(
            `${Apis.MANAGE_REPORT.GET_WALLET_TRANSACTIONS_REPORT}`,
            "GET",
            {},
            { params },
            true
          );

          if (res?.data?.status === "SUCCESS") {
            const rows = [...res.data.data.data];

            const formatted = rows.map((item) => ({
              "Transaction Date": formatDateFunction(item.createdAt, "dd/mm/yyyy", true),
              "Delivery Date": item.deliveryDate
                ? formatDateFunction(item.deliveryDate, "dd/mm/yyyy", true)
                : "-",
              "Order Number": item.orderId || "-",
              "Type": item.transactionDetails?.type,
              "Amount": roundToDecimal(item.amount, 2),
              "Closing Balance": roundToDecimal(item.walletClosingBalance, 2),
              "Description": item.additionalNote || "-",
              "Distance": item.transactionDetails?.distance || "-",
              "Vendor Total Amount":
                item.transactionDetails?.priceDetails?.vendor_total_amount ||
                item.transactionDetails?.priceDetails?.pickup_vendor_total_amount ||
                "-",
              "Delivery Fees":
                item.transactionDetails?.priceDetails?.delivery_fees || "-",

              "Total Delivery Fees":
                item.transactionDetails?.priceDetails?.total_delivery_fees || "-",

              "Vendor Deductions":
                item.transactionDetails?.deductionDetails?.vendor_deduction ||
                item.transactionDetails?.deductionDetails?.pickupvendor_deduction ||
                "-",
            }));


              if (value === "csv") {
                exportCSV(formatted, "wallet-report.csv");
              } else {
                exportPDf(
                  Object.keys(formatted[0]),
                  formatted.map((i) => Object.values(i)),
                  "wallet-report.pdf"
                );
              }
            }
          } catch (e) {
            toast.error(e.message);
          }
          dispatch(changeLoader(false));
        };
    
      if(mainTabIndex === 9 || mainTabIndex === "9"){
          dispatch(changeLoader(true));
          try {
            const params = { ...inputData, type: "export" };

            const res = await globalRequest(
              `${Apis.MANAGE_REPORT.GET_DRIVER_REPORT}`,
              "GET",
              {},
              { params },
              true
            );

            if (res?.data?.status === "SUCCESS") {
              const rows = [...res.data.data.data];

            const formatted = rows.map((item) => ({
                "Date": formatDateFunction(item.eventsDate, "dd/mm/yyyy", true),
                "Driver Name": item.driverDetails?.user?.firstName + " " + item.driverDetails?.user?.lastName || "-",
                "Latest Location": item.driverDetails?.lat && item.driverDetails?.lng ? `${item.driverDetails?.lat}, ${item.driverDetails?.lng}` : "-",
                "Latest Event": item.events?.length > 0 ? getEventLabel(item.events[item.events.length - 1]?.type) || "-" : "-",
                "All Events": item?.events?.length > 0
                      ? item.events
                          .map((event) => {
                            return `${getEventLabel(event.type)} | ${formatDateFunction(
                              event.timeStamp, "yyyy-mm-dd", true, "at"
                            )} | ${
                              event.distanceFromPrevEvent
                                ? Number(event.distanceFromPrevEvent).toFixed(2) + " km"
                                : "0 km" } |                      
                            ${event?.orderNumber || "-"} |
                            ${event.driverLatitude && event.driverLongitude ? `${event.driverLatitude}, ${event.driverLongitude}` : "-"} |
                            ${event.branchName || "-"} `
                          })
                          .join(" \n ")
                      : "-",
             }));
             if (value === "csv") {
                exportCSV(formatted, "driver-report.csv");
              } else {
                exportPDf(
                  Object.keys(formatted[0]),
                  formatted.map((i) => Object.values(i)),
                  "driver-report.pdf"
                );
              }
            }
          } catch (e) {
            toast.error(e.message);
          }
          dispatch(changeLoader(false));
        };
      
      if (mainTabIndex === 10 || mainTabIndex === "10") {
        dispatch(changeLoader(true));
        try {
          const params = { ...inputData, type: "export" };

          const res = await globalRequest(
            `${Apis.MANAGE_REPORT.GET_ADMIN_ACTIVITY_LOGS}`,
            "GET",
            {},
            { params },
            true
          );

          if (res?.data?.status === "SUCCESS") {
            const rows = [...(res.data.data.data || res.data.data || [])];

            const formatted = rows.map((item) => ({
              "Date": formatDateFunction(item.dateTime, "dd/mm/yyyy hh:mm a"),
              "User Name": item.userName || "-",
              "Method": item.method || "-",
              "URL": item.url || "-",
              "Payload": JSON.stringify(item.body || {}),
            }));

            if (formatted.length > 0) {
              if (value === "csv") {
                exportCSV(formatted, "admin-activity-logs.csv");
              } else {
                exportPDf(
                  Object.keys(formatted[0]),
                  formatted.map((i) => Object.values(i)),
                  "admin-activity-logs.pdf"
                );
              }
            } else {
              toast.error("No data found to export.");
            }
          }
        } catch (e) {
          toast.error(e.message);
        }
        dispatch(changeLoader(false));
      }
    }
  };

  const [mainTabIndex, setMainTabIndex] = useState(locationState.mainTabIndex || "1");
  const [subTabIndex, setSubTabIndex] = useState(locationState.subTabIndex || "1");
  //change tab index
  const changeTabIndex = (index) => {
    setMainTabIndex(index);
  };
  const changeSubTabIndex = (index) => {
    setSubTabIndex(index);
  };

  useEffect(() => {
    if (
      checkPermissionAction("Sales By Zone Report", permissionJson, "view") ||
      checkPermissionAction("Sales By Item Report", permissionJson, "view") ||
      checkPermissionAction("Sales By Customer Report", permissionJson, "view") ||
      checkPermissionAction("Sales By Order Type Report", permissionJson, "view") ||
      checkPermissionAction("Sales By Delivery Mode Report", permissionJson, "view") ||
      checkPermissionAction("Sales By Time Slot Report", permissionJson, "view") ||
      checkPermissionAction("Sales By Vendor Report", permissionJson, "view") ||
      checkPermissionAction("Sales By Driver Report", permissionJson, "view")
    )
      setMainTabIndex(locationState.mainTabIndex || "1");
    else if (checkPermissionAction("Coupon Report", permissionJson, "view")) setMainTabIndex("2");
    else if (checkPermissionAction("Payment Report", permissionJson, "view")) setMainTabIndex("3");
    else if (checkPermissionAction("Refund Order Report", permissionJson, "view")) setMainTabIndex("4");
    else if (checkPermissionAction("Late Order Report", permissionJson, "view")) setMainTabIndex("5");
    else if (checkPermissionAction("Cancelled Order Report", permissionJson, "view")) setMainTabIndex("6");
    else if (checkPermissionAction("Sales Details Report", permissionJson, "view")) setMainTabIndex("7");
    else if (checkPermissionAction("Wallet Reports", permissionJson, "view")) setMainTabIndex("8");
    else if (checkPermissionAction("Driver Reports", permissionJson, "view")) setMainTabIndex("9");
    else if (checkPermissionAction("Admin Activity Logs", permissionJson, "view")) setMainTabIndex("10");
  }, [permissionJson, locationState.mainTabIndex]);

  return (
    <>
      <Card>
        <div className="flex flex-wrap justify-between	mb-4 gap-5 ">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              Report
            </Typography>
          </div>
          <div className="flex flex-wrap gap-3">
            <Form form={form} layout="vertical">
              <Form.Item name="search">
                <div className="flex flex-wrap gap-3">
                  <RangePicker
                    className="cursor-pointer"
                    onChange={handleDateChange}
                    value={[
                      inputData?.start_date ? dayjs(inputData?.start_date, "YYYY-MM-DD") : null,
                      inputData?.end_date ? dayjs(inputData?.end_date, "YYYY-MM-DD") : null,
                    ]}
                    // defaultValue={ inputData.start_date && inputData.end_date ? [dayjs(inputData.start_date, 'YYYY-MM-DD'), dayjs(inputData.end_date, 'YYYY-MM-DD')] : null}
                    format="YYYY-MM-DD"
                    allowClear={false}
                  />
                  <Search
                    placeholder="Search"
                    style={{
                      width: window.innerWidth < 768 ? "100%" : 200,
                    }}
                    // value={inputData?.search}
                    className="cursor-pointer"
                    onChange={(e) => {
                      const value = Validation.strFormat(e.target.value, "trim");
                      handleSearchDebounced(value); // Debounced function
                    }}
                  />
                </div>
              </Form.Item>
            </Form>
            <div className="flex flex-wrap gap-3">
              {mainTabIndex === "1" && subTabIndex === "1" && checkPermissionAction("Sales By Zone Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "1" && subTabIndex === "2" && checkPermissionAction("Sales By Item Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "1" &&
              subTabIndex === "3" &&
              checkPermissionAction("Sales By Customer Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "1" &&
              subTabIndex === "4" &&
              checkPermissionAction("Sales By Order Type Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "1" &&
              subTabIndex === "5" &&
              checkPermissionAction("Sales By Delivery Mode Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "1" &&
              subTabIndex === "6" &&
              checkPermissionAction("Sales By Time Slot Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "1" &&
              subTabIndex === "7" &&
              checkPermissionAction("Sales By Vendor Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "1" &&
              subTabIndex === "8" &&
              checkPermissionAction("Sales By Driver Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}

              {mainTabIndex === "2" && checkPermissionAction("Coupon Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "3" && checkPermissionAction("Payment Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "4" && checkPermissionAction("Refund Order Report",permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "5" && checkPermissionAction("Late Order Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "6" && checkPermissionAction("Cancelled Order Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "7" && checkPermissionAction("Sales Details Report", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "8" && checkPermissionAction("Wallet Reports", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "9" && checkPermissionAction("Driver Reports", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
              {mainTabIndex === "10" && checkPermissionAction("Admin Activity Logs", permissionJson, "export") ? (
                <>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("csv");
                    }}
                  >
                    Download in CSV
                  </Button>
                  <Button
                    type="primary"
                    size={14}
                    icon={<DownloadOutlined />}
                    className="cursor-pointer"
                    onClick={() => {
                      exportData("pdf");
                    }}
                  >
                    Download in PDF
                  </Button>
                </>
              ) : null}
            </div>
          </div>
        </div>
        <Tabs activeKey={mainTabIndex} onChange={changeTabIndex}>
          {checkPermissionAction("Sales By Zone Report", permissionJson, "view") ||
          checkPermissionAction("Sales By Item Report", permissionJson, "view") ||
          checkPermissionAction("Sales By Customer Report", permissionJson, "view") ||
          checkPermissionAction("Sales By Order Type Report", permissionJson, "view") ||
          checkPermissionAction("Sales By Delivery Mode Report", permissionJson, "view") ||
          checkPermissionAction("Sales By Time Slot Report", permissionJson, "view") ||
          checkPermissionAction("Sales By Vendor Report", permissionJson, "view") ||
          checkPermissionAction("Sales By Driver Report", permissionJson, "view") ? (
            <Tabs.TabPane tab={"Sales Reports"} key={1}>
              {mainTabIndex === "1" && (
                <SalesReports inputData={inputData} changeSubTabIndex={changeSubTabIndex} permissionJson={permissionJson} initialSubTabIndex={locationState.subTabIndex} />
              )}
            </Tabs.TabPane>
          ) : null}
          {checkPermissionAction("Coupon Report", permissionJson, "view") ? (
            <Tabs.TabPane tab={"Discount/coupon Reports"} key={2}>
              {mainTabIndex === "2" && <DiscountCouponReports inputData={inputData} setInputData={setInputData} />}
            </Tabs.TabPane>
          ) : null}
          {checkPermissionAction("Payment Report", permissionJson, "view") ? (
            <Tabs.TabPane tab={"Payment Reports"} key={3}>
              {mainTabIndex === "3" && <PaymentReports inputData={inputData} setInputData={setInputData} />}
            </Tabs.TabPane>
          ) : null}
          {checkPermissionAction("Refund Order Report",permissionJson, "view") ? (
           <Tabs.TabPane tab={"Refund Order Reports"} key={4}>
              {mainTabIndex === "4" && <RefundOrdersReports inputData={inputData} setInputData={setInputData} />}
            </Tabs.TabPane>
          ) : null}
          {checkPermissionAction("Late Order Report", permissionJson, "view") ? (
            <Tabs.TabPane tab={"Late Order Reports"} key={5}>
              {mainTabIndex === "5" && <LateOrdersReports inputData={inputData} setInputData={setInputData} />}
            </Tabs.TabPane>
          ) : null}
          {checkPermissionAction("Cancelled Order Report", permissionJson, "view") ? (
            <Tabs.TabPane tab={"Cancelled Order Reports"} key={6}>
              {mainTabIndex === "6" && <CancelledReports inputData={inputData} setInputData={setInputData} />}
            </Tabs.TabPane>
          ) : null}
          {checkPermissionAction("Sales Details Report", permissionJson, "view") ? (
            <Tabs.TabPane tab={"Sales Details Reports"} key={7}>
              {mainTabIndex === "7" && <SalesDetailsReport inputData={inputData} setInputData={setInputData} />}
            </Tabs.TabPane>
          ) : null}
          {checkPermissionAction("Wallet Reports", permissionJson, "view") ? (
            <Tabs.TabPane tab={"Wallet Reports"} key={8}>
              {mainTabIndex === "8" && <WalletReports inputData={inputData} setInputData={setInputData} />}
            </Tabs.TabPane>
          ) : null}
          {checkPermissionAction("Driver Reports", permissionJson, "view") ? (
            <Tabs.TabPane tab={"Driver Reports"} key={9}>
              {mainTabIndex === "9" && <DriverReports inputData={inputData} setInputData={setInputData} />}
            </Tabs.TabPane>
          ) : null}
          {checkPermissionAction("Admin Activity Logs", permissionJson, "view") ? (
            <Tabs.TabPane tab={"Admin Activity Logs"} key={10}>
              {mainTabIndex === "10" && <AdminActivityLogsReports inputData={inputData} setInputData={setInputData} />}
            </Tabs.TabPane>
          ) : null}
        </Tabs>
      </Card>
    </>
  );
};
export default Report;
